<div class="input-wrapper">
    <div class="arrow-anchor ">
        <input [(ngModel)]="value" [placeholder]="placeholder" autocomplete="off" class="custom-input has-error-message" 
            [ngClass]="{'invalid-input': ngControl.invalid, 'touched-input': ngControl.touched, 'dirty-input': ngControl.dirty}"
            (blur)="setTouched()" (focus)="setFocused()">
        <img src="assets/icons/close.svg" class="remove-input" *ngIf="value" (click)="removeValue()">
    </div>
    <div class="error-message" *ngIf="ngControl.control.errors && ngControl.touched && !focused" [class.expand-errors]="(ngControl.control.errors ?? {} | keyvalue).length > 1">
        <div *ngFor="let error of (ngControl.control.errors ?? {}) | keyvalue">{{errorMessages[error.key]}}</div>
    </div>
</div>
